import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import AutoplayVideos from './components/AutoplayVideos';
import BarbaApp from './barba/BarbaApp';
import Menu from './components/Menu';
import './components/CopyText';
import './components/VideoModule';
import './components/VideosSlider';
import Map from './modules/Map';

export class Alfred {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		new Menu();
		new AutoplayVideos();
		new BarbaApp();
		new Map();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();
